import 'CssFolder/schedule/jpo/jpo-report.scss';
import { PopoverPosition, Tooltip } from "construct-ui";
import moment from 'moment';
import { v4 as uuidv4 } from 'uuid';
import MultiSelectComponent from '../../../components/multi-select/multi-select.component';
import SingleSelectComponent from "../../../components/single-select/single-select.component";
import { codeMasterType } from "../../../config/constants";
import scheduleModel from "../../../models/schedule/jpo-schedule.model";
import ViewBase from "../../view-base.view";

export default function PlanWorkloadOverview() {
    ViewBase.call(this)

    let imceTypeList = [];
    let userRoleList = [];
    let adminList = [];
    let userRoleListByFilter = [];
    let supervisorList = [];
    let supervisorListByFilter = [];
    let tableData = [];
    let imceTypeOld = '';
    let initLoadData = false;
    let isSubsidiaryAdmin = 0;
    let daysOfmonth = 31;
    let nonWorkingDayList = [];

    const DEFAULT_FILTERS = {
        monthYear: moment().format("YYYY-MM"),
        imceType: {},
        userRole: {},
        supervisors: [],
    };

    let inputDataModel = { filterDate: "", BU: "", SupervisorRoles: "", SupervisorIds: "" };
    let filters = structuredClone(DEFAULT_FILTERS);
    let startDateofMonth = moment(filters.monthYear).startOf('month').format('YYYYMMDD');
    let endDateofMonth = moment(filters.monthYear).endOf('month').format('YYYYMMDD');

    let oldFilters = structuredClone(filters);

    let getAdmin = () => {
        adminList = [];
        scheduleModel.getSchedulePlanAndActualCodeMaster(
            (result) => {
                if (result) {
                    result.forEach(e => {
                        adminList.push({ ...e });
                    });
                    isSubsidiaryAdmin = adminList.filter(x => x.code == 'SubsidiaryAdmin' && x.mapData == 1).length > 0 ? 1 : 0;
                }
            },
            (error) => {
                this.handleError(error);
            },
            {
                type: 'SummaryRptAdmin',
            }
        )
    }

    const getImceTypeList = () => {
        imceTypeList = [];
        scheduleModel.getSchedulePlanAndActualCodeMaster(
            (result) => {
                if (result) {
                    imceTypeList = result;
                    filters.imceType = imceTypeList.length > 0 ? imceTypeList[0] : {};
                    imceTypeOld = filters.imceType.code;
                    getUserRoleList();
                }
            },
            (error) => {
                this.handleError(error);
            },
            {
                type: codeMasterType.bu,
            }
        )
    }

    let getUserRoleList = () => {
        userRoleList = [];
        scheduleModel.getSchedulePlanAndActualCodeMaster(
            (result) => {
                if (result) {
                    result.forEach(e => {
                        userRoleList.push({ ...e });
                    });
                    getUserRoleListByFilter();
                }
            },
            (error) => {
                this.handleError(error);
            },
            {
                type: 'SupervisorRole',
            }
        )
    }

    let getUserRoleListByFilter = () => {
        userRoleListByFilter = [];
        if (userRoleList) {
            userRoleListByFilter = userRoleList.filter(x => x.mapData == filters.imceType.code);
            if (userRoleListByFilter.length > 0) {
                filters.userRole = userRoleListByFilter[0];
                if (initLoadData) {
                    getSupervisorList();
                } else {
                    getSupervisorListByFilter();
                }
            }
        } else {
            getUserRoleList();
        }
    }

    let getNonWorkingDay = () => {
        userRoleList = [];
        scheduleModel.getSchedulePlanAndActualCodeMaster(
            (result) => {
                if (result) {
                    result.forEach(e => {
                        nonWorkingDayList.push({ ...e });
                    });
                }
            },
            (error) => {
                this.handleError(error);
            },
            {
                type: 'NonStoreVisitDay',
                //mapData: filters.imceType.code
            }
        )
    }

    let getSupervisorList = () => {
        supervisorList = [];
        this.showLoading();
        scheduleModel.getSchedulePlanAndActualCodeMaster(
            (result) => {
                if (result) {
                    result.forEach(e => {
                        supervisorList.push({ ...e });
                    });
                }

                getSupervisorListByFilter();
                this.hideLoading();
            },
            (error) => {
                this.handleError(error);
                this.hideLoading();
            },
            {
                type: 'SupervisorOrLeadSupervisor',
                mapData: userRoleList.map(i => i["code"]).join(',')
            }
        );
    }

    let getSupervisorListByFilter = () => {
        supervisorListByFilter = [];
        filters.supervisors = [];
        if (supervisorList) {
            supervisorListByFilter = supervisorList.filter(x => x.mapData == filters.userRole.code);

            if (initLoadData) {
                initLoadData = false;
                getSchedulePlanWorkloadOverviewList();
            }
        } else {
            getSupervisorList();
        }
    }

    let getSchedulePlanWorkloadOverviewList = () => {
        this.showLoading();
        scheduleModel.getSchedulePlanWorkloadOverviewList(
            (result) => {
                tableData = result;

                const filterMonthYear = filters.monthYear.replace('-', '');
                var year = filterMonthYear.slice(0, 4);//moment().year();
                var month = filterMonthYear.slice(4, 6); //moment().month() + 1; //0 based, need to +1
                getDaysInMonth(month, year);
                
                oldFilters = structuredClone(filters);
                this.hideLoading();
            },
            (error) => {
                this.handleError(error);
                this.hideLoading();
            },
            {
                filterDate: filters.monthYear.replace('-', ''),
                BU: filters.imceType.code,
                SupervisorIds: filters.supervisors.map(i => i["code"]).join(','),
                SupervisorRoles: filters.userRole.code,

            }
        )
    }

    const onSearch = (e) => {
        startDateofMonth = moment(filters.monthYear).startOf('month').format('YYYYMMDD');
        endDateofMonth = moment(filters.monthYear).endOf('month').format('YYYYMMDD');
        search();
    }

    let onClear = () => {
        filters.monthYear = moment().format("YYYY-MM"),
        filters.userRole = userRoleListByFilter[0];
        filters.supervisors = [];
        search();
    }

    let search = () => {
        getSchedulePlanWorkloadOverviewList();
    }

    let _downloadExcel = () => {
        this.showLoading();
        var fileName = uuidv4();

        if (oldFilters) {
            inputDataModel.filterDate = oldFilters.monthYear.replace('-', '');
            if (oldFilters.imceType.code != "")
                inputDataModel.BU = oldFilters.imceType.code;
            else
                inputDataModel.BU = "";
            if (oldFilters.supervisors.length > 0)
                inputDataModel.SupervisorIds = oldFilters.supervisors.map(i => i["code"]).join(',');
            else
                inputDataModel.SupervisorIds = "";
            inputDataModel.SupervisorRoles = oldFilters.userRole.code;

        }
        else {
            this.showErrorMessage(
                this.getText("", "Please select the filter."),
                this.getText("EM00000142", "Error")
            )
        }
        scheduleModel.jpoWorkloadOverviewDownloadExcel(
            (result) => { this.hideLoading(); },
            (error) => {
                this.hideLoading();
                this.handleError(error);
            },
            inputDataModel, fileName
        )
    }

    let getDaysInMonth = (month, year) => {
        daysOfmonth = new Date(year, month, 0).getDate();
    }

    const getDayOfWeek = (day) => {
        const filterMonthYear = oldFilters.monthYear.replace('-', '');
        var year = filterMonthYear.slice(0, 4);
        var month = filterMonthYear.slice(4, 6);

        const date = new Date(year, month - 1, day);
        const days = ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"];
        return days[date.getDay()];
    };

    const getTdElement = (data, threshold, key, type) => {
        let className = "";
        if (type != 1) {
            //no need to add color
        }
        else if (data === null || data === '') {
            //check non working day            
            var day = getDayOfWeek(key.replace("d", ""));
            var bNonworkingDay = nonWorkingDayList.some(n => n.mapData == oldFilters.imceType.code && n.code == day && n.mapData2 == oldFilters.userRole.code);
            if (!bNonworkingDay) {
                className = '.jpo-bg-danger';
            }

        } else if (data.length > 0 && !/^\d{2}:\d{2}$/.test(data)) {
            className = '.bg-yellow';
            var arrData = data.split(',');
            if (arrData.length > 1) {
                var arrTime = arrData[0].split(':');
                var hrs = parseInt(arrTime[0]);
                var mins = parseInt(arrTime[1]);
                data = String(hrs).padStart(2, '0') + "h : " + String(mins).padStart(2, '0') + "m" + " ," + arrData[1];
            }
        } else {
            const timeParts = data.split(':');
            const hours = parseInt(timeParts[0]);
            const minutes = parseInt(timeParts[1]);

            const totalHours = hours + (minutes / 60);

            if (totalHours < threshold) {
                className = '.jpo-bg-danger';
            }

            return m('td.jpo-td' + className, m('span.cursor-text', String(hours).padStart(2, '0') + "h : " + String(minutes).padStart(2, '0') + "m"));

        }

        return m('td.jpo-td' + className, m('span.cursor-text', data));
    };

    const getToolTipContent = (content) => {
        const arrContent = content.split('<br>');
        return m('div',
            arrContent.reduce((acc, item, index) => {
                acc.push(m('span', item));
                if (index < arrContent.length - 1) {
                    acc.push(m('br'));
                }
                return acc;
            }, [])
        );
    }

    const getTrigger = (trigger1, trigger2, trigger3) => {
        const triggers = [trigger1, trigger2, trigger3].filter(t => t != null);
        const cTrigger = triggers.flatMap((t, i) => [
            m('span', t),
            i < triggers.length - 1 ? m('br') : null
        ]);

        return m('div', cTrigger);
    }

    const getToolTips = (content, trigger1, trigger2, trigger3) => {

        return m(Tooltip, {
            content: getToolTipContent(content),
            hoverOpenDelay: 250,
            hoverCloseDelay: 250,
            openOnTriggerFocus: true,
            position: PopoverPosition.TOP,
            trigger: getTrigger(trigger1, trigger2, trigger3)
        })
    };

    const getLegend = () => {
        return m('.d-flex.align-items-center', { 'style': 'padding-left : 5px;' },
            m('ul.jpo-simple-legend.horizontal',
                m('li',
                    m('strong', 'LV'), ' - ', this.getText("", "Leave")
                ),
                m('li',
                    m('strong', 'DO'), ' - ', this.getText("", "Day Off")
                ),
                m('li',
                    m('strong', 'TR'), ' - ', this.getText("", "Training")
                ),
                m('li',
                    m('strong', 'RS'), ' - ', this.getText("", "Roadshow")
                ),
            )
        );
    };

    const getLinkTd = (data, seq) => {
        const tdAttrs = {
            class: (data.type == 10) ? "jpo-td-start sticky-col-total sticky-col-" + seq : "jpo-td-start sticky-col sticky-col-" + seq
        };

        if (data.storeIds != null) {
            tdAttrs.onclick = () => {
                m.route.set('/schedule/visit-rate', null, {
                    state: {
                        supervisorIDs: { 'userID': data.userId, 'userName': data.userName },
                        siteIDs: data.storeIds.split(","),
                        //storeGrade: data.grade,
                        fromDate: startDateofMonth,
                        toDate: endDateofMonth,
                        bu: { 'code': oldFilters.imceType.code, 'name': oldFilters.imceType.name }
                    }
                });
            };
        }

        const spanAttrs = (data.storeIds != null) ?
            { style: 'color: #0077C8; cursor: pointer;' } : {};

        return m('td', tdAttrs,
            m('span.cursor-text', spanAttrs, data.userName)
        );
    };

    return {
        oninit: () => {
            initLoadData = true;
            getAdmin();
            getImceTypeList();
            getNonWorkingDay();
        },
        view: () => {
            return [
                // SEARCH
                m(".card.mb-3",
                    m(".card-body",
                        m('.row.g-4',
                            m('.col-md-2',
                                m("label.form-label", this.getText("LT00000326", "Month")),
                                m("input.form-control.form-control-bg",
                                    {
                                        "type": "month",
                                        "value": filters.monthYear,
                                        onchange: (e) => {
                                            e.redraw = false;
                                            filters.monthYear = e.target.value;
                                        }
                                    }
                                ),
                            ),
                            m('.col-md-2',
                                m("label.form-label", this.getText("LT00000817", "MX/CE Store")),
                                m(SingleSelectComponent, {
                                    id: "imce",
                                    items: imceTypeList,
                                    selectedItem: filters.imceType,
                                    checkmark: true,
                                    filterable: true,
                                    required: true,
                                    allowEmpty: false,
                                    onSelect: (s) => {
                                        if (imceTypeOld != s.code && s.code != '') {
                                            filters.imceType = s;
                                            filters.userRole = userRoleListByFilter[0];
                                            filters.supervisors = [];
                                            getUserRoleListByFilter();
                                            imceTypeOld = s.code;
                                        }
                                    },
                                })
                            ),
                            m('.col-md-3',
                                m('label.form-label', this.getText("LT00000060", "User Role")),
                                m(SingleSelectComponent, {
                                    items: userRoleListByFilter,
                                    selectedItem: filters.userRole,
                                    allowEmpty: false,
                                    onSelect: (s) => {
                                        filters.userRole = s;
                                        getSupervisorListByFilter();
                                    }
                                }),
                            ),
                            m('.col-md-3',
                                m('label.form-label', this.getText(isSubsidiaryAdmin == 1 ? "LT00008108" : "LT00000271", isSubsidiaryAdmin == 1 ? "Lead Supervisor" : "Supervisor")),
                                m(MultiSelectComponent, {
                                    items: supervisorListByFilter,
                                    selectedItems: filters.supervisors,
                                    onSelect: (s) => {
                                        filters.supervisors = s;
                                    }
                                }),
                            ),
                            m(".col-xl-2.col-lg-6.d-flex.align-items-end.justify-content-start.gap-2",
                                m('button.btn.btn-primary',
                                    {
                                        onclick: () => {
                                            onSearch();
                                        },
                                    },
                                    this.getText("LT00000001", "Search")),

                                m('button.btn.btn-white', { onclick: onClear }, this.getText("LT00000031", "Clear")),
                            ),
                        ),
                    )
                ),
                // SEARCH - end

                // Table section
                m('.card',
                    m('.card-body',
                        m('.row.g-2 ',
                            m('.col-12.p-0',
                                m('.d-flex.justify-content-between.mb-2',
                                    getLegend(),

                                    m('a.btn.btn-primary', { onclick: _downloadExcel },
                                        m('i.bi.bi-file-earmark-arrow-down-fill'), this.getText("LT00000018", "Excel Download"),
                                    )
                                ),
                                m('.jpo-table-responsive-workload.table-responsive',
                                    m('table.table.table-hover',
                                        m('thead',
                                            m('tr.align-middle',
                                                m("th.jpo-border-left.jpo-header.text-start.sticky-col.sticky-col-1", { "scope": "col" }, this.getText("LT00008116", "Supervisor / Day")), //this.getText("LT00000271", "Supervisor")),

                                                m("th.jpo-header.text-center", { "scope": "col" },
                                                    getToolTips(this.getText("LT00008122", "Half-Man-Day (for hours < 4)<br>Full-Man-Day (for hours >= 4)<br>Man-Month = Total Man-Days / Working Days in Month"),
                                                        this.getText("LT00008117", "Man Month"), this.getText("LT00008120", "(by Working Days)"), null),
                                                ),

                                                m("th.jpo-header.text-center", { "scope": "col" },
                                                    getToolTips(this.getText("LT00008123", "Man-Month = Total Working Hours / (Working Days in Month × 8 hr/day)<br>*Total Working Hours = Store Visit Hours + Stay in Office Hours"),
                                                        this.getText("LT00008117", "Man Month"), this.getText("LT00008121", "(by Working Hours)"), null),
                                                ),

                                                Array.from({ length: daysOfmonth }, (v, i) =>
                                                    m("th.jpo-header.text-center", { "scope": "col" },
                                                        getToolTips(this.getText("LT00008124", "Summary of Store Visit Hours and Stay in Office Hours"),
                                                            this.getText("", (i + 1) + "(" + getDayOfWeek(i + 1) + ")"), null, null),
                                                    )
                                                ),

                                            )
                                        ),
                                        m('tbody',
                                            (tableData == null) &&
                                            m('tr.align-middle',
                                                m('td[colSpan=34]', this.getText("EM00000141", "No records found."))
                                            ),

                                            tableData != null &&
                                            tableData.map((data, index) =>
                                                m('tr.align-middle',

                                                    //m("td.jpo-td-start",
                                                    //    data.storeIds != null ? {
                                                    //        onclick: () => {
                                                    //            m.route.set('/schedule/visit-rate', null, {
                                                    //                state: {
                                                    //                    supervisorIDs: { 'userID': data.userId, 'userName': data.userName },
                                                    //                    siteIDs: data.storeIds.split(","),
                                                    //                    //storeGrade: data.grade,
                                                    //                    fromDate: startDateofMonth,
                                                    //                    toDate: endDateofMonth,
                                                    //                    bu: { 'code': filters.imceType.code, 'name': filters.imceType.name }
                                                    //                }
                                                    //            })
                                                    //        },
                                                    //    } : {},
                                                    //    m("span.cursor-text", data.storeIds != null ?
                                                    //        { style: 'color: #0077C8; cursor: pointer;' } : {}, data.userName)),

                                                    getLinkTd(data, 1),

                                                    m("td.jpo-td", m("span.cursor-text", data.manDay)),
                                                    m("td.jpo-td", m("span.cursor-text", data.actualWorkDay)),

                                                    Object.keys(data)
                                                        .filter(key => key.startsWith('d') && key !== 'd29' && key !== 'd30' && key !== 'd31')
                                                        .map(key => getTdElement(data[key], data.avgHours, key, data.type)),

                                                    (daysOfmonth >= 29) && getTdElement(data.d29, data.avgHours, "d29", data.type),
                                                    (daysOfmonth >= 30) && getTdElement(data.d30, data.avgHours, "d30", data.type),
                                                    (daysOfmonth > 30) && getTdElement(data.d31, data.avgHours, "d31", data.type),
                                                )
                                            )


                                        )
                                    ),
                                ),
                                //Paganation
                            )
                        )
                    )
                ),
                // Table section - end
                this.getBaseViews()
            ];
        }
    }
}